import api from '../service/api'
import { responseBuild } from "./utils";

const service = api;

export const getEstadosCivil = async () => {
    let request = await service.get(`/candidatos/estados-civil`).then(responseBuild);
    if (request && request.length > 0) {
        return request
    }
    return []
}

export const getGeneros = async () => {
    let request = await service.get(`/candidatos/generos`).then(responseBuild);
    if (request && request.length > 0) {
        return request
    }
    return []
}

export const getClacificacionesPuesto = async () => {
    let request = await service.get(`/candidatos/clasificaciones-puesto`).then(responseBuild);
    if (request && request.length > 0) {
        return request
    }
    return []
}

export const getGirosEmpresa = async () => {
    let request = await service.get(`/candidatos/giros-empresa`).then(responseBuild);
    if (request && request.length > 0) {
        return request
    }
    return []
}

export const getMotivosSalida = async () => {
    let request = await service.get(`/candidatos/motivos-salida`).then(responseBuild);
    if (request && request.length > 0) {
        return request
    }
    return []
}

export const getEspecialidades = async () => {
    let request = await service.get(`/candidatos/especialidades`).then(responseBuild);
    if (request && request.length > 0) {
        return request
    }
    return []
}

export const getIdiomas = async () => {
    let request = await service.get(`/candidatos/idiomas`).then(responseBuild);
    if (request && request.length > 0) {
        return request
    }
    return []
}

export const getNivelesEstudio = async () => {
    let request = await service.get(`/candidatos/niveles-estudio`).then(responseBuild);
    if (request && request.length > 0) {
        return request
    }
    return []
}

export const getBeneficios = async () => {
    let request = await service.get(`/candidatos/beneficios`).then(responseBuild);
    if (request && request.length > 0) {
        return request
    }
    return []
}

export const getPrestaciones = async () => {
    let request = await service.get(`/candidatos/prestaciones`).then(responseBuild);
    if (request && request.length > 0) {
        return request
    }
    return []
}

export const getConocimientos = async () => {
    let request = await service.get(`/candidatos/conocimientos`).then(responseBuild);
    if (request && request.length > 0) {
        return request
    }
    return []
}

export const getTiposContratacion = async () => {
    let request = await service.get(`/candidatos/tipos-contratacion`).then(responseBuild);
    if (request && request.length > 0) {
        return request
    }
    return []
}

export const getTiposJornada = async () => {
    let request = await service.get(`/candidatos/tipos-jornada`).then(responseBuild);
    if (request && request.length > 0) {
        return request
    }
    return []
}

export const getNivelesConocimiento = async () => {
    let request = await service.get(`/candidatos/niveles-conocimiento`).then(responseBuild);
    if (request && request.length > 0) {
        return request
    }
    return []
}

export const getNacionalidades = async () => {
    let request = await service.get(`/candidatos/nacionalidades`).then(responseBuild);
    if (request && request.length > 0) {
        return request
    }
    return []
}

